/**
 * Create the get function for the times API
 */
export function createGetTimes(context) {
  /**
   * Return either a single or array of times properties from move nodes
   */
  return function get(index?: number): number[] | number | undefined {
    const { api } = context;

    const mainLine = api.getLine(0);

    if (index !== undefined) {
      return mainLine[index]?.time;
    }

    return mainLine.map((move) => move.time);
  };
}
